import { action } from 'easy-peasy';
import { IActionResetClientAllocationAvailability } from '../types';

const resetClientAllocationAvailability: IActionResetClientAllocationAvailability = action(
  state => {
    state.dateAvailability = null;
  },
);

export default resetClientAllocationAvailability;
